import { VehicleTestData } from '../../../../../types/showcaseBlockType';

export const getSlugForLabel = (data: VehicleTestData[], value: string) => {
  const itemIndex = data.findIndex((item) => item.name === value);
  return itemIndex > -1 ? data[itemIndex].slug : undefined;
};
